import { z } from 'zod'

import { BusinessErrorSchema } from 'shared/api/common/schemas/errors'

export const IsFbmmCreateCampaignBudgetErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('daily_budget').or(z.literal('lifetime_budget')),
})

export const IsFbAccountSettingsErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('account_id'),
})

export const IsCustomAudienceActionTokenErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('token_error').or(z.literal('permissions')),
})
